import exports_api from "../../api/exports";
import {useEffect, useState} from "react";
import GenericDialog from "../../components/GenericDialog";
import auth from "../../api/auth";


const Marketing = () => {

    // Error Dialog
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogText, setDialogText] = useState("")
    const buttons = [{"text":"OK", "id": "1"}];

    useEffect(() => {
        auth.hasSession().then((session) => {
            if (!session) window.location.assign("/logout");
        });
    }, [])

    const downloadResponsesCSV = (type) => {
        let response = exports_api.getAllResponses(type)
        response.then(
            response => {
                // Download File
                let data = response.data.data
                let base64_link = "data:text/csv;base64," + data
                const anchor = document.createElement("a");
                anchor.href = base64_link;
                anchor.download = type+".csv";
                anchor.click();
            }
        ).catch((err) => {
            setDialogTitle("Fetching Error")
            setDialogText("There was an getting the requested data. Please try again")
        })

    }

    const downloadCSV = (filename, text) => {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';

        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    const handleErrorDialogResult = (res) => {
        if(!res) return;
        setDialogText("")
        setDialogTitle("")
    }

    return (
        <div className="page-container">
            <div className="page-title">
                Marketing
            </div>
            <div className="page-subtitle">
                Initial
            </div>
            <div className="button link" onClick={() => downloadResponsesCSV("initial")}>
                Download All Initial Responses
            </div>
            <div className="page-subtitle">
                Mid
            </div>
            <div className="button link" onClick={() => downloadResponsesCSV("mid")}>
                Download All Mid Responses
            </div>
            <div className="page-subtitle">
                End
            </div>
            <div className="button link" onClick={() => downloadResponsesCSV("end")}>
                Download All End Responses
            </div>
            {dialogText && dialogText ? <GenericDialog title={dialogTitle} text={dialogText} buttons={buttons}
                                                       result={handleErrorDialogResult.bind(this)}/> : null}
        </div>
    )
}

export default Marketing